import { render, staticRenderFns } from "./PopupEditPriceGroup.vue?vue&type=template&id=0f5f7163&scoped=true&"
import script from "./PopupEditPriceGroup.vue?vue&type=script&lang=js&"
export * from "./PopupEditPriceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f7163",
  null
  
)

export default component.exports